import { ActionContext } from 'vuex';
import { Interactive } from '@/models/Interactive';
import { Store } from '@/models/Store';

const state: Interactive = {
  level: 0,
  level1SawAnswer: false,
  level1Clear: false,
  level2Clear: false,
  level2SawAnswer: false,
  finished: false,
  routeAddress: '/timeline/recommendation/0003',
  newDay2ContentAddress: ''
};

const getters = {
  level (moduleState: Interactive) {
    return moduleState.level;
  },
  answerLevel1 (moduleState: Interactive) {
    return moduleState.level1SawAnswer;
  },
  answerLevel2 (moduleState: Interactive) {
    return moduleState.level2SawAnswer;
  },
  clearLevel1 (moduleState: Interactive) {
    return moduleState.level1Clear;
  },
  clearLevel2 (moduleState: Interactive) {
    return moduleState.level2Clear;
  },
  finished (moduleState: Interactive) {
    return moduleState.finished;
  },
  routeAddress (moduleState: Interactive) {
    return moduleState.routeAddress;
  },
  newDay2ContentAddress (moduleState: Interactive) {
    return moduleState.newDay2ContentAddress;
  }
};

const mutations = {
  setLevel (moduleState: Interactive, level: number) {
    moduleState.level = level;
  },
  level1Answer (moduleState: Interactive, sawAnswer: boolean) {
    moduleState.level1SawAnswer = sawAnswer;
  },
  level2Answer (moduleState: Interactive, sawAnswer: boolean) {
    moduleState.level1SawAnswer = sawAnswer;
  },
  level1Clear (moduleState: Interactive, setSuccess: boolean) {
    moduleState.level1Clear = setSuccess;
  },
  level2Clear (moduleState: Interactive, setSuccess: boolean) {
    moduleState.level2Clear = setSuccess;
  },
  setFinish (moduleState: Interactive, finish: boolean) {
    moduleState.finished = finish;
  },
  setRouteAddress (moduleState: Interactive, route: string) {
    moduleState.routeAddress = route;
  },
  setNewDay2ContentAddress (moduleState: Interactive, newDay2ContentAddress: string) {
    moduleState.newDay2ContentAddress = newDay2ContentAddress;
  }
};

const actions = {
  changeLevel (action: ActionContext<Interactive, Store>, level: number) {
    action.commit('setLevel', level);
  },
  sawAnswer (action: ActionContext<Interactive, Store>, data: {sawAnswer: boolean; level: number}) {
    data.level === 1 ? action.commit('level1Answer', data.sawAnswer) : action.commit('level2Answer', data.sawAnswer);
  },
  setSuccess (action: ActionContext<Interactive, Store>, data: {setSuccess: boolean; level: number}) {
    data.level === 1 ? action.commit('level1Clear', data.setSuccess) : action.commit('level2Clear', data.setSuccess);
  },
  setFinish (action: ActionContext<Interactive, Store>, finish: boolean) {
    action.commit('setFinish', finish);
  },
  setFirstRoute (action: ActionContext<Interactive, Store>, route: string) {
    action.commit('setRouteAddress', route);
  },
  updateNewDay2ContentAddress (action: ActionContext<Interactive, Store>, newDay2ContentAddress: string) {
    action.commit('setNewDay2ContentAddress', newDay2ContentAddress);
  }
};

export const interactive = {
  state,
  getters,
  mutations,
  actions
};
